import mainLogo from './opp_main_logo.png'
import passwordIcon from './icons/password_icon.svg'
import userIcon from './icons/user_icon.svg'
import sampleAvatar from './sample_avatar.jpg'
import emailIcon from './icons/email_icon.svg'
import openInNewWindowIcon from './icons/open_in_new_window.svg'

const images = {
  mainLogo,
  passwordIcon,
  sampleAvatar,
  userIcon,
  emailIcon,
  openInNewWindowIcon,
}

export default images
